import { render, staticRenderFns } from "./CrudSearch.vue?vue&type=template&id=0f895013"
import script from "./CrudSearch.vue?vue&type=script&lang=js"
export * from "./CrudSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports